module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image@2-405023e4d0dddf4d548919b0994f98b3.jpg";